/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TicketScanRequest
 */
export interface TicketScanRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketScanRequest
     */
    barcode: string;
}

/**
 * Check if a given object implements the TicketScanRequest interface.
 */
export function instanceOfTicketScanRequest(value: object): value is TicketScanRequest {
    if (!('barcode' in value) || value['barcode'] === undefined) return false;
    return true;
}

export function TicketScanRequestFromJSON(json: any): TicketScanRequest {
    return TicketScanRequestFromJSONTyped(json, false);
}

export function TicketScanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketScanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'barcode': json['barcode'],
    };
}

export function TicketScanRequestToJSON(value?: TicketScanRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'barcode': value['barcode'],
    };
}

